import { atom } from "jotai";
import { focusAtom } from "jotai/optics";
import { atomFamily } from "jotai/utils";

import { createDerivedSessionAtom } from "atoms/utils/createDerivedSessionAtom";
import { createPersistedAtom } from "atoms/utils/createPersistedAtom";
import { PaymentQuestions } from "pages/SpeedyPayment/PayeeQuestions/types";


const sessionQuestionsAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<PaymentQuestions>(`acceptanceQuestions-${sessionId}`, {})
);

export const paymentQuestionsAtom = createDerivedSessionAtom<PaymentQuestions>(sessionQuestionsAtom);

export const getQuestionAtom = atomFamily((property: keyof PaymentQuestions) =>
  focusAtom(paymentQuestionsAtom, (optic) => optic.prop(property))
);

export const paymentQuestionAtom = atom((get) => ({
  ...get(paymentQuestionsAtom),
}));

